import moment from 'moment';


// this good place to set the redux initial state of the web app
export const setAppInitialState = (/* store */) => {
    console.log('Initial func called');
};


export const loggedIn = () => {
    return true;
};

export const requireAuth = (nextState, replace) => {
    if (!loggedIn()) {
        replace({
            pathname: '/login',
        });
    }
};

export const getLocalStorage = (key) => {
    return localStorage.getItem(key);
};

export const setLocalStorage = (keys) => {
    if (Array.isArray(keys) || keys instanceof Array) {
        const length = keys.length;
        for (let i = 0; i < length; i++) { localStorage.setItem(keys[i].key, keys[i].value); }
        return;
    }
    localStorage.setItem(keys.key, keys.value);
};

export const getDateFromServerDate = (dataString) => {
    const dateObject = [];
    if (dataString) {
        dateObject.push(dataString.toString().substring(0, 4));
        dateObject.push(dataString.toString().substring(4, 6));
        dateObject.push(dataString.toString().substring(6, 8));

        return moment(dateObject.join('/'));
    }
    return dateObject;
};

export const transformDays = (daysArr) => {
        return daysArr.map((item) => {
                const dateObj = {};
                dateObj.date = getDateFromServerDate(item.date);
                dateObj.rawDate = item.date;
                dateObj.id = item.id;
                return dateObj;
            });
};

export const transformBadDays = (daysArr) => {
    if (daysArr.length) {
        const filteredArr = daysArr.filter(cal => cal.reservationStatus === 'held').concat(daysArr.filter(cal => cal.reservationStatus === 'booked'));
        return transformDays(filteredArr);
    }
    return [];
};

export const transformGoodDays = (daysArr) => {
    if (daysArr.length) {
        const filteredArr = daysArr.filter(cal => cal.reservationStatus === 'open');
        return transformDays(filteredArr);
    }
    return [];
};


export const getGridsizeByType = (type) => {
    switch (type) {
        case 1:
                return 'quarter';
        case 2:
                return 'half';
        case 3:
                return 'three-quarters';
        case 4:
                return 'full';
        default:
            return 'half';
    }
};

export const getAllCityIcons = () => {
    return ['rome.svg', 'jerusalem.svg', 'telaviv.svg', 'paris.svg', 'barcelona.svg', 'brussels.svg', 'lisbon.svg'];
};

export const emailToUsername = email => email.split('@').join('#');

export const generateRowKey = () => {
    const number = Math.random(); // 0.9394456857981651
    number.toString(36); // '0.xtis06h6'
    return number.toString(36).substr(2, 9); // 'xtis06h6'
};



// WEBPACK FOOTER //
// ./src/lib/utils.js